export function getDifference(
  a: number,
  b: number
): number {
  return a - b
}